import * as React from 'react';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { FavouriteEditMenuComponentProps } from 'app/area/favourite-administration/form/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './favourite-edit-menu.scss';

export const FavouriteEditMenu = (props: FavouriteEditMenuComponentProps) => {
  const { id, name, fetching, translation, onDelete } = props;

  const handleDelete = () => {
    onDelete(id);
  };

  return (<MeatballMenu className={styles.meatball}>
    <li>
      <PromptConfirmationModal
        title={translation.delete_favourite_title}
        description={replaceTemplateString(
          translation.delete_confirmation,
          name)}
        continueText={translation.delete_favourite_button}
        cancelText={translation.cancel}
        onContinue={handleDelete}>
        <button type="button" className="dropdown-item" disabled={fetching}>
          {translation.delete_favourite_button}
        </button>
      </PromptConfirmationModal>
    </li>
  </MeatballMenu>);
};
